export default "__VITE_ASSET__B10Yunf0__"